<template>
  <responsive-drawer-header
    :badgeColor="'primary'"
    :badgeCount="0"
    :color="theme.appBar.other.color"
    :headerBg="theme.appBar.other.bg"
    :closeDrawerTooltip="$t('closeDrawerHint')"
    :openDrawerTooltip="$t('openDrawerHint')"
    :hasDrawer="false"
  >
    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      <common-dialog
        :id="dialog.id"
        @onOk="onOk"
        @onCancel="onCancel"
        :okText="dialog.okText"
        :cancelText="dialog.cancelText"
        :title="dialog.title"
        :text="dialog.text"
        :params="dialog.params"
        v-model="dialog.isOpen"
      ></common-dialog>
      <div class="d-flex caption" v-if="moduleTitleWithQuestionTitle">{{ moduleTitleWithQuestionTitle }}</div>
    </template>

    <template v-slot:right>
      <v-btn v-if="showBackButton" class="d-flex pl-0" :color="color" text rounded @click="back()">
        <v-icon>mdi-chevron-left</v-icon>
        {{ $t('back') }}
      </v-btn>
      <div v-if="timeout && isExamRoute" class="d-flex justify-center">
        <countdown :timeInMinutes="timeout" @onTimerExpired="onTimerExpired"></countdown>
      </div>
    </template>
  </responsive-drawer-header>
</template>

<script>
import CommonDialog from '@/dialogs/CommonDialog';
import NTitle from '@/components/texts/NTitle';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import Countdown from './Countdown.vue';
import { mapState } from 'vuex';
import elearningMixin from './ElearningMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import constants from './constants';

const { ROUTES } = constants;
export default {
  mixins: [common, configMixin, navigationMixin, elearningMixin],
  components: { ResponsiveDrawerHeader, Countdown, CommonDialog },
  data() {
    return {
      selectedGroup: 0,
    };
  },
  computed: {
    ...mapState('elearning', ['dataLoaded', 'modulesById', 'userStateByModuleId', 'currentQuestion', 'next', 'dialog']),

    showBackButton() {
      return [ROUTES.EXAM_RESULT, ROUTES.TRAINING_RESULT, ROUTES.TRAINING].indexOf(this.$route.name) >= 0;
    },

    moduleTitleWithQuestionTitle() {
      if (this.elmx_moduleFromRoute && this.currentQuestion) {
        return `${this.elmx_moduleFromRoute.name} - ${this.currentQuestion.title}`;
      }
      if (this.elmx_moduleFromRoute) return `${this.elmx_moduleFromRoute.name}`;
      return null;
    },

    color() {
      return this.theme.appBar.other.color;
    },
    timeout() {
      return this.elmx_moduleFromRoute ? this.elmx_moduleFromRoute.timeout : null;
    },
    isExamRoute() {
      return this.$route.name === constants.ROUTES.EXAM;
    },
  },
  methods: {
    onOk(dialogId, { module }) {
      console.debug('onOk from ', dialogId, 'module', module);
      switch (dialogId) {
        case 'interruptExam':
          console.debug('interruptExam requested but ignoring since not allowed');
          break;
        case 'interruptTraining':
          if (this.dialog && this.dialog.next) {
            this.dialog.next();
            //TODO: set state
            let userState = this.elmx_getModuleUserState(module);

            //userState.status = constants.STATUS.canceled;
            let text = this.$t('el.trainingInterrupted', { moduleName: module.name });
            this.elmx_createAndSendSendboxItem({
              module,
              userState,
              text,
              action: 'saveStateTransition',
              showAsUserInfo: true,
              showInSendbox: false,
              writeAuditLog: false,
            });
          }
          break;
        case 'examStartConfirm': {
          let text = this.$t('el.examStartMsg', { moduleName: module.name });
          let userState = this.elmx_getModuleUserState(module);

          this.elmx_createAndSendSendboxItem({
            module,
            userState,
            text,
            action: 'saveStateTransition',
            showAsUserInfo: true,
            showInSendbox: true,
            writeAuditLog: true,
          });
          this.elmx_goTo(module, 0);
          break;
        }
        case 'timerExpired':
          this.elmx_goToResult(module);
          break;
        case 'interruptExamWithNoTimeout':
          if (this.dialog && this.dialog.next) {
            this.dialog.next();
            //TODO: set state
            let userState = this.elmx_getModuleUserState(module);

            //userState.status = constants.STATUS.canceled;
            let text = this.$t('el.examInterrupted', { moduleName: module.name });
            this.elmx_createAndSendSendboxItem({
              module,
              userState,
              text,
              action: 'saveStateTransition',
              showAsUserInfo: true,
              showInSendbox: false,
              writeAuditLog: false,
            });
          }
          break;
      }
    },
    onCancel(dialogId) {
      console.debug('onCancel from ', dialogId);
      switch (dialogId) {
        case 'interruptTraining':
          // no action
          break;
        case 'interruptExamWithNoTimeout':
          // no action
          break;
      }
    },
    onTimerExpired() {
      this.$store.commit('elearning/setDialog', {
        id: 'timerExpired', // dialog id that is provided with callbacks
        isOpen: true,
        title: this.$t('el.timerExpiredTitle'),
        text: this.$t('el.timerExpired'),
        okText: this.$t('ok'),
        params: { module: this.elmx_moduleFromRoute },
      });
    },
    back() {
      this.$router.push({ name: constants.ROUTES.HOME });
    },
    onCountdownEnd() {
      console.debug('onCountdownEnds');
    },
  },
};
</script>
